import React, { FC } from "react";
import { HardwareSubCmds } from "../../../../constants/sub-commands";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import ModesColumns from "../../../../models/ColumnDefinitions/ModeColumns";
import { ListData } from "../../../../models/ListData";
import { ListQuery } from "../../../../models/ListQuery";
import TableTab from "../../../tabs/table-tab";
import { WizardStepLayout } from "../../../wizard/wizard-summary-layout";
export interface SelectBiometricTypeProps {
    onNext: (e) => void;
    selectedBrand: any;
    setSelectedBrand: (mode: any) => void;
}

export const SelectScanFilters: FC<SelectBiometricTypeProps> = ({ onNext, selectedBrand, setSelectedBrand }) => {
    const { translate } = useLocale();

    const onRowClicked = (rowData: any) => {
        const newSelectedMode = {
            ...selectedBrand,
            id: rowData.id,
            name: rowData.nameOriginal,
            value: rowData.value,
        }
        setSelectedBrand(newSelectedMode);
    }

    const getFilterTypes = (listParameters?: ListQuery): Promise<ListData> => {
        const rows = [{
            id: 1,
            name: "Idemia",
            value: HardwareSubCmds.Discover_Idemia,
            nameOriginal: "Idemia"
        },
        {
            id: 2,
            name: "Control iD",
            value: HardwareSubCmds.Discover_ControlId,
            nameOriginal: "Control iD"
        },
        {
            id: 3,
            name: "Hikvision",
            value: HardwareSubCmds.Discover_HIK_Vision,
            nameOriginal: "HikVision"
        },
        {
            id: 4,
            name: "Hid Amico",
            value: HardwareSubCmds.Discover_ControlId,
            nameOriginal: "Hid Amico"
        }]

        return new Promise((resolve, reject) => {
            return resolve({
                rows: rows,
                pagination: { maxPageSize: 10, pageNumber: 1, totalCount: rows.length, totalPages: 1 }
            });
        })
    }

    const handleNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        // todo?: set ip address values if one is selected but the other not.
        // if () {
        // }
        if (onNext && selectedBrand.id){
            onNext(e);
        }
    };

    return (
        <WizardStepLayout onNext={handleNext} nextDisabled={!selectedBrand.id}>
            <div className="flex flex-row pt-3">
                <TableContextProvider
                    dataMethod={getFilterTypes}
                    tableDescriptor={ModesColumns}
                    searchDescriptor={[]}
                    useTable
                    usePagination
                    canExportReport={false}>
                    <TableTab
                        title={translate.byKey(TranslationKeys.selectABrand)}
                        selectRows={false}
                        onRowClicked={(data) => onRowClicked(data)}
                        customHighlightRow={selectedBrand?.id ? { fieldName: 'id', comparisonValue: selectedBrand.id } : undefined}
                        cyName="selectScanFilter"/>
                </TableContextProvider>
            </div>
        </WizardStepLayout>
    );
};
